<template>
  <Form class="modalFormWrap formStyle" ref="form" :model="newInfo" label-position="left" :rules="rules">
    <Row :gutter="30">
      <Col span="12">
        <FormItem prop="name" label="活动名称">
          <Input type="text" v-model="newInfo.name"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="organizer" label="活动主办机构">
          <Input type="text" v-model="newInfo.organizer"></Input>
        </FormItem>
      </Col>
      <Col :md="12" :xs="24">
        <Col span="24" class="ivu-form-item-required">
          <span class="ivu-form-item-label">活动所在地</span>
        </Col>
        <Col span="8">
          <FormItem prop="locId" :label-width="0">
            <Select 
              v-model="newInfo.locId" 
              placeholder="所在地" 
              @on-open-change="getLocList"
              @on-change="locSelect">
              <Option v-for="item in locList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="stateId" :label-width="0">
            <Select 
              v-model="newInfo.stateId" 
              placeholder="省份/大洲" 
              @on-open-change="getStateList"
              @on-change="stateSelect">
              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="cityId" :label-width="0">
            <Select 
              v-model="newInfo.cityId" 
              placeholder="城市/国家" 
              @on-open-change="getCityList"
              @on-change="citySelect">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <!-- <Col span="8" v-if="newInfo.locId==0">
          <FormItem prop="stateId" :label-width="0">
            <Select 
              v-model="newInfo.stateId" 
              placeholder="大洲" 
              @on-open-change="getStateList"
              @on-change="stateSelect">
              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8" v-if="newInfo.locId==0">
          <FormItem prop="cityId" :label-width="0">
            <Select 
              v-model="newInfo.cityId" 
              placeholder="国家" 
              @on-open-change="getCityList"
              @on-change="citySelect">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col> -->
      </Col>
      <Col span="12">
        <FormItem prop="job" label="担任职务">
          <Select v-model="newInfo.job" placeholder="">
            <Option value="主办">主办</Option>
            <Option value="策划">策划</Option>
            <Option value="组织">组织</Option>
            <Option value="嘉宾">嘉宾</Option>
            <Option value="核心骨干">核心骨干</Option>
            <Option value="其他">其他</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="otherJob" label="其他职务">
          <Input type="text" v-model="newInfo.otherJob"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="date" label="活动时间">
          <DatePicker type="month" format="yyyy-MM" value-format="yyyy-MM" :clearable="false" :editable="false" v-model="newInfo.date" @on-change="newInfo.completionDate=$event"></DatePicker>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem label="活动类型（可多选）">
          <Select v-model="newInfo.activityType" multiple placeholder="">
            <Option value="论坛">论坛</Option>
            <Option value="展览">展览</Option>
            <Option value="培训">培训</Option>
            <Option value="演出">演出</Option>
            <Option value="聚会">聚会</Option>
            <Option value="线上">线上</Option>
            <Option value="线下">线下</Option>
            <Option value="公益">公益</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :md="12" :xs="24">
        <FormItem prop="url" label="相关链接">
          <Input type="text" v-model="newInfo.url"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <span class="ivu-form-item-label">报道证明</span>
      </Col>
      <Col span="24">
        <div>
          <Upload
            ref="imgBtn"
            :action="imgApi"
            :headers="{Authorization: token}"
            name="picture"
            :data="{applyType: 'CERTIFICATE', 'fileIndex': 0}"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :before-upload="handleBeforeUpload" 
            :on-format-error="handleFormatError"
            :on-error="handleError"
            :on-exceeded-size="handleSize"
            :on-progress="handleProgress"
            :max-size="5120"
            accept="image/jpg, image/png, image/jpeg">
            <Tooltip theme="light" max-width="200" placement="bottom-start">
              <Button class="defaultBtn size12" shape="circle">上传报道证明图片</Button>
              <div slot="content" class="size12">
                <p>可上传格式：JPG，PNG。</p>
              </div>
            </Tooltip>
          </Upload>
        </div>
        <div class="imgWrap" >
          <template v-if="newInfo.certificate">
            <img v-if="newInfo.certificate" class="img" :src="getImageUrl(newInfo.certificate, 'avatar')" alt="">
            <div class="imgMask">
              <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(newInfo.certificate))" />
              <Icon type="ios-close-circle-outline" class="delImg" @click="removeImg()"/>
            </div>
          </template>
          <template v-else>
            <Progress v-if="fileUpload.showProgress" :percent="fileUpload.percentage" hide-info></Progress>
          </template>
          <Modal v-model="showLargePic"
            title="查看图片" 
            :footer-hide="true"
            :styles="{top: '50px'}"
            width=640>
            <img :src="largePicPath" v-if="showLargePic" style="width: 100%">
          </Modal>
        </div>
      </Col>
    </Row>
    <div class="btnWrap">
      <p class="textLeft pdBtm"><span class="addBtn" @click="addActivity">添加其它社会活动</span></p>
      <Button class="defaultBtn formBtn" shape="circle" @click="submit">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </Form>
</template>

<script>
import personalService from '@/api/personal'
import centerService from '@/api/center'
import { baseUrl } from '@/config/env'
export default {
  props: ['info'],
  data(){
    return{
      imgApi: `${baseUrl}picture/upload`,
      token: this.$store.getters.token,
      countryList: [],
      newInfo: {},
      fileUpload: {showProgress: false, percentage: 0},
      rules: {
        name: [{required: true, message: "请输入活动名称", trigger: 'blur,change'}],
        organizer: [{required: true, message: "请输入活动主办机构", trigger: 'blur,change'}],
        job: [{required: true, message: "请选择担任职务", trigger: 'blur,change'}],
        locId: [{required: true, message: "请选择所在地", trigger: 'blur,change', type: 'number'}],
        stateId: [{required: true, message: "请选择省份/大洲", trigger: 'blur,change', type: 'number'}],
        cityId: [{required: true, message: "请选择城市/国家", trigger: 'blur,change', type: 'number'}],
        date: [{required: true, message: "请选择活动时间", trigger: 'blur,change', pattern: /.+/}],
      },
      submitting: false,
      showLargePic: false,
      largePicPath: '',
      // 国家
      locList: [],
      stateList: [],
      inStateList: [],
      outStateList: [],
      cityList: [],
    }
  },
  mounted(){
    this.newInfo = Object.assign({}, {locId: 1, stateId: null, cityId: null}, this.info)
    // this.newInfo = Object.assign([], this.info)
    // for(let i=0,l=this.info.length;i<l;i++){
    //   this.newInfo[i] = Object.assign({}, this.info[i])
    // }
    if(this.newInfo.activityType){
      this.newInfo.activityType = this.newInfo.activityType.split(',')
    }
    // if(this.newInfo.date){
    //   this.newInfo.date = new Date(this.newInfo.date + '-' + '01')
    // }
    this.getLocations()
    this.getLocations('state')
    this.getLocations('city')
  },
  methods:{
    // 上传图片成功
    handleSuccess(res) {
      if (res.errorNo) {
        this.$Message.error(res.errorMessage)
      } else {
        let data = res.data
        this.newInfo.certificate = data.path
        this.fileUpload.showProgress = false
        this.fileUpload.percentage = 0
        // this.$forceUpdate()
      }
    },
    handleBeforeUpload(file) {
      let check = true
      if(file.size == 0){
        check = false
      }
      this.fileUpload.showProgress = true
      return check;
    },
    handleProgress(event){
      this.fileUpload.percentage = event.percent
    },
    // 文件超出最大值5M
    handleSize(){
      this.$Message.info('文件超过最大值5M，请重新选择！')
    },
    // 文件格式错误提示
    handleFormatError (file) {
      this.$Message.error(`文件${file.name}格式错误`)
    },
    // 错误提示
    handleError(error){
      this.$Message.error('服务器错误' + error)
    },
    getCountryList(){
      centerService.getAllCountry()
      .then(res => {
        if(res.errorNo==0){
          this.countryList = res.data
        }else{
          this.$Message.error(res.errorMessage)
        }
      }).catch( () => {
        // this.$Message.error(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    // 添加
    addActivity(){
      this.newInfo = {locId: 1}
    },
    // 提交信息
    submit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true
          if((typeof this.newInfo.date) != 'string'){
            let dt = this.newInfo.date
            // console.log(dt)
            dt.setHours(dt.getHours() + 8)
            // console.log(dt)
            let sYear = dt.getFullYear() + ''
            let sMonth = (dt.getMonth() + 1) < 10 ? '0' + (dt.getMonth() + 1) : (dt.getMonth() + 1) + ''
            // let sDate = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate() + ''
            let dNew = sYear + '-' + sMonth
            // this.newInfo.date = dt.getFullYear() + '-' + (dt.getMonth() + 1)
            this.newInfo.date = dNew
          }
          console.log(this.newInfo.date)
          if(this.newInfo.activityType){
            this.newInfo.activityType = this.newInfo.activityType.join(',')
          }
          personalService.saveActivity(this.newInfo)
          .then(res => {
            if(res.errorNo==0){
              this.$parent.$parent.getActivityList()
              this.skip()
            }else{
              this.$Message.error(res.errorMessage)
            }
            this.submitting = false
          }).catch(err => {
            this.submitting = false
            // this.$Message.error(err.message)
            console.log(err.message)
            this.$Message.error('连接服务器失败，请稍后再试')
          })
        }else{
          this.$Message.error('信息未填写完整')
        }
      })
    },
    // 提交全部信息
    submitAll(){
      let k = 0, l = this.newInfo.length
      for(let i=0; i<l; i++){
        this.$refs[`newForm${i}`][0].validate(valid => {
          if (valid) {
            if((typeof this.newInfo[i].date) != 'string'){
              let dt = this.newInfo[i].date
              dt.setHours(dt.getHours() + 8)
              this.newInfo[i].date = dt.getFullYear() + '-' + (dt.getMonth() + 1)
            }
            k++
          }else{
            // this.$Message.error('信息未填写完整')
          }
        })
      }
      // console.log(k+'_'+l)
      if(k != l){
        this.$Message.error('信息未填写完整')
        return
      }
      this.submitting = true
      personalService.saveAllActivity(this.newInfo)
      .then(res => {
        if(res.errorNo==0){
          this.$parent.$parent.getActivityList()
          this.skip()
        }else{
          this.$Message.error(res.errorMessage)
        }
        this.submitting = false
      }).catch(err => {
        this.submitting = false
        // this.$Message.error(err.message)
        console.log(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    getCountryName(countryId){
      for(let i=0; i<this.countryList.length; i++){
        if(this.countryList[i].id == countryId){
          return this.countryList[i].name
        }
      }
    },
    // 选中国家
    locSelect(){
      this.stateList = []
      this.newInfo.stateId = ''
      this.stateSelect()
      this.$forceUpdate()
    },
    // 选中省份
    stateSelect(){
      this.cityList = []
      this.newInfo.cityId = ''
      this.$forceUpdate()
    },
    // 选中城市
    citySelect(){
      this.$forceUpdate()
    },
    // 获取国家列表
    getLocList(flag){
      if(flag && this.locList.length==0){
        this.getLocations('loc')
      }
    },
    // 获取省份列表
    getStateList(flag){
      if(flag){
        this.$refs.form.validateField('locId', valid => {
          if(!valid){
            if(this.newInfo.locId==0 && this.outStateList.length==0 
              || this.newInfo.locId==1 && this.inStateList.length==0){
              this.getLocations('state')
            }else{
              this.stateList = this.newInfo.locId==0 ? this.outStateList : this.inStateList
            }
          }
        })
      }
    },
    // 获取城市列表
    getCityList(flag){
      if(flag){
        this.$refs.form.validateField('stateId', valid => {
          if(!valid){
            this.getLocations('city')
          }
        })
      }
    },
    // 获取位置列表
    getLocations(flag){
      let promise
      if(flag=='city'){
        promise = centerService.getLocations({'parentid.eq': this.newInfo.stateId})
      }else if(flag=='state'){
        promise = centerService.getLocations({'parentid.eq': this.newInfo.locId})
      }else{
        promise = centerService.getLocations()
      }
      promise.then(res => {
        if(res.errorNo==0){
          if(flag=='city'){
            this.cityList = res.data
          }else if(flag=='state'){
            this.stateList = res.data
            if(this.newInfo.locId==0){
              this.outStateList = res.data
            }
            if(this.newInfo.locId==1){
              this.inStateList = res.data
            }
          }else{
            this.locList = res.data
          }
        }else{
          this.$Message.error(res.errorMessage)
        }
      }).catch(() => {
        // this.$Message.error(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    setDate(val){
      this.newInfo.date = val
      this.$refs.form.validateField('date')
    },
    // 查看大图
    openImg(path){
      // window.open(path, '_blank')
      this.showLargePic = true
      this.largePicPath = path
    },
    // 删除图片
    removeImg(){
      this.newInfo.certificate = null
    },
    skip(){
      this.$emit('Skip', {key: 'activityInfo'})
    }
  }
}
</script>